import useSWR from 'swr'
import OrganizationService from '@forwardflow/services/OrganizationService'
import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'

export function useGetMonthlyBudgets() {
   return useSWR(
      QUERY_KEYS.MONTHLY_BUDGETS,
      () => OrganizationService.getMonthlyBudgets(),
      {
         revalidateOnFocus: false,
      }
   )
}
